/* ACTION TYPE CONTANTS */

export const UPDATE_ABORT_CONTROLLER_RESOURCE =
  'app/core/UPDATE_ABORT_CONTROLLER_RESOURCE';
